import React from "react";
import PropTypes from "prop-types";
import Hgroup from "public-components/Hgroup";
import Container from "public-components/Container";
import styles from "./FeaturesGridSection.module.scss";

import BeautyRetouchingIcon from "./icons/beauty-retouching.svg";
import CoolEffectsIcon from "./icons/cool-effects.svg";
import IntuitiveEditingIcon from "./icons/intuitive-editing.svg";
import PhotoCollageIcon from "./icons/photo-collage.svg";
import RichResourcesIcon from "./icons/rich-resources.svg";
import TemplateSizesIcon from "./icons/template-sizes.svg";

import RoundBG from "assets/background/round.svg";

const iconsEnum = {
  beautyRetouching: BeautyRetouchingIcon,
  coolEffects: CoolEffectsIcon,
  intuitiveEditing: IntuitiveEditingIcon,
  photoCollage: PhotoCollageIcon,
  richResources: RichResourcesIcon,
  templateSizes: TemplateSizesIcon
};

const FeaturesGridSection = ({ data }) => {
  return (
    <section className={styles.featureGrid}>
      <RoundBG className={styles.featureGrid__round} />
      <Container>
        <Hgroup className={styles.featureGrid__hgroup} heading={data.headingH2} />
        <div className={styles.featureGrid__row}>
          {data.homeFeaturesList.map(i => (
            <div className={styles.featureGrid__item} key={i.id}>
              <div className={styles.feature}>
                <div className={styles.feature__icon}>{React.createElement(iconsEnum[i.icon])}</div>
                <h3 className={styles.feature__heading}>{i.heading}</h3>
                <div
                  className={styles.feature__text}
                  dangerouslySetInnerHTML={{ __html: i.text }}
                />
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

FeaturesGridSection.propTypes = {
  data: PropTypes.shape({
    headingH2: PropTypes.string.isRequired,
    homeFeaturesList: PropTypes.arrayOf(PropTypes.object)
  }).isRequired
};

export default FeaturesGridSection;
